import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
    
  }
  
  home= [
    {'id':1, 'title':'Commitment', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/images-1.jpg'},
    {'id':2, 'title':'Integrity', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia quod voluptatem tempore saepe.', 'image':'../../assets/integrity.jpeg'},
    {'id':3, 'title':'Quality', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia quod voluptatem .', 'image':'../../assets/quality.jpg'},
    {'id':4, 'title':'Service', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/service.jpg'},
  ]
  team= [
    {'id':1, 'title':'Founder', 'name':'Alzaro', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/images-1.jpg'},
    {'id':2, 'title':'Co-Founder', 'name':'Alzaro', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/images-1.jpg'},
    
  ]
  products= [
    {'id':1, 'title':'Coconut Briquette Charcoal', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/coconut-briquette-charcoal.jpg'},
    {'id':2, 'title':'Palm Sugar', 'description':'Lorem ipsum dolor sit amet consectetur adipisicing elit.', 'image':'../../assets/palm-sugar.jpg'},
  ]

}
